export default "__VITE_ASSET__TBeYp3ua__"